export default {
  redeemCode: {
    title: 'Tukar Kode',
    description: 'Masukkan kode penukaran Anda di bawah ini untuk mengklaim hadiah Anda.',
    enterTip: 'Masukkan kode penukaran Anda untuk mengklaim hadiah',
    label: 'Kode Penukaran',
    placeholder: 'Masukkan kode penukaran',
    submit: 'Tukar',
    redeemBtn: 'TUKAR',
    submitting: 'Menukar...',
    success: 'Kode berhasil ditukar!',
    redeemSuccess: 'Kode berhasil ditukar!',
    failed: 'Gagal menukar kode, silakan coba lagi.',
    redeemFailed: 'Gagal menukar kode, silakan coba lagi.'
  }
};
